import type { ReactElement } from 'react';

import type { ISingleHistoryBet, ISingleHistoryGame } from '../../../../../../api/fetchers/history/types';
import { CurrencyConnected } from '../../../../../currency/CurrencyConnected';
import { L12nText } from '../../../../../text';
import styles from '../../HistoryBetInfo.module.css';

interface BoomorbustProps {
  bets: ISingleHistoryBet[];
  game: ISingleHistoryGame;
}

const BETS_MAP: Record<string, string> = {
  '1x': '1x',
  '2x': '2x',
  '5x': '5x',
  BG3: 'Dice Battle',
  BG2: 'Lucky Drop',
  BG1: 'Boom or Bust',
};

export default function BoomorbustTableResult({ bets, game }: BoomorbustProps): ReactElement {
  return (
    <>
      <thead>
        <tr>
          <td className={styles.table_head}>
            <L12nText tk="BETTYPE" />
          </td>
          <th className={styles.table_head}>
            <L12nText tk="BET_LABEL" />
          </th>
          <th className={styles.table_head}>
            <L12nText tk="NETCASH" />
          </th>
        </tr>
      </thead>
      <tbody>
        {bets.map((bet: ISingleHistoryBet, index: number) => {
          const parsedBet = getDescription(bet.description);
          return (
            <tr key={`boomorbust_${index}`}>
              <td>{BETS_MAP[parsedBet] || parsedBet}</td>
              <td>
                <CurrencyConnected value={Number(bet.amount)} />
              </td>
              <td className={Number(bet.netCash) > 0 ? styles.win : styles.lose}>
                {game.cancelled && Number(bet.netCash) == 0 ? (
                  <span className={styles.refunded}>
                    <L12nText tk="REFUNDED" />
                  </span>
                ) : (
                  <CurrencyConnected value={Number(bet.netCash)} />
                )}
              </td>
            </tr>
          );
        })}
      </tbody>
    </>
  );
}

const getDescription = (text: string): string => {
  if (text[0] == '{') {
    const parsed = JSON.parse(text);
    return parsed.cardNo || parsed[Object.keys(parsed)[0]];
  }
  return text;
};
